import React, { useContext } from 'react';
import { StateContext } from "../../state";
import LoadingBar from "./LoadingBar";
import ConfigComponent from "../ConfigComponent";

export const LoadingPage = ({title, description , imgSrc, showLoadingImg = true}) => {
  const [{configuration}] = useContext(StateContext);
  const { loadingPage: {imgSrc: loadingImg} } = configuration;

  return (
    <div className="loading-page">
      {showLoadingImg && (imgSrc || loadingImg) && <div className="splash-container"><img className="splash-img" src={imgSrc || loadingImg} alt="" /></div>}
      {title && <h1 className="title"><ConfigComponent config={title}/></h1>}
      <LoadingBar />
      {description && <p className="description"><ConfigComponent config={description}/></p>}
      {showLoadingImg && (imgSrc || loadingImg) && <div className="splash-container"/>} {/* conditionally including an extra splash container to offset the above splash container and keep the loading message in the center of the screen*/}
    </div>
  );
};

export default LoadingPage;
